module.exports = __webpack_public_path__ + "static/media/dashboard-selected.b0e2ab47.png";